import { combineReducers, configureStore, PreloadedState } from '@reduxjs/toolkit';

import { eventSlice } from './features/event-slice';

export const defaultReducers = {
  event: eventSlice.reducer,
};
const rootReducer = combineReducers(defaultReducers);

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    preloadedState,
    reducer: rootReducer,
  });

export const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

export default store;
